
import ToogleColorTheme from './ToogleColorTheme';
export default ToogleColorTheme;